/** If the number contains only one character, a leading 0 will be added.
 */
import dayjs from 'dayjs'
import { t } from 'i18next'

/** returns empty string if undefined and else the date formatted as we would expect it in switzerland.
 * Excluding hours and minutes. */
export const getFormattedDateWithoutHours = (date: Date): string => {
	if (date === undefined || !typeof date) {
		return ''
	}
	const realDate = new Date(date)
	return dayjs(realDate).format(t<string>('locales.dateFormat'))
}

export const isSet = (date: any) => {
	return date !== undefined && date !== null && date !== ''
}

export const getFormattedDateForMySQL = (date: Date | string | undefined | null): (string | undefined) => {

	if (!date) {
		return undefined
	}

	let realDate: Date

	// check if date is already a date or a string
	if (date instanceof Date) {
		realDate = date
	} else {
		realDate = new Date(date)
	}

	// if date was a string with invalid format it will return undefined
	if (!realDate) {
		return undefined
	}
	return dayjs(realDate).format('YYYY-MM-DD')
}